import type { FaireProductEntity } from "../../entity_types/product";

export const p_p7nfyqkufk: FaireProductEntity = {
  token: "p_p7nfyqkufk",
  type: "product",
  name: "Zircon Inlaid Cross 18K Gold Plated S.Steel Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/50bdbb82925c3f487f7b4485ca3ec78cf1fd8e93da412de30d756966018f509c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1793ce58111940ff0eb028b5fbbb6eea40ffc23856958e1020c1f93c68d13f2.jpeg",
    "https://cdn.faire.com/fastly/30f3f9166eeae15c67aa062c1d583443444d89b2aa9a2d80669b11fbad5e387d.jpeg",
    "https://cdn.faire.com/fastly/827d6a89360051e9b3ef6c1190f31dafa6ea6eef306102ceacfbcbefff06657b.jpeg",
    "https://cdn.faire.com/fastly/e308eb9fc424150e84b1c42cff7d829adc43e731a80c52cc2a5726a777b2381b.jpeg",
    "https://cdn.faire.com/fastly/6e6832d0240df86f7f8a53b551fe77d3446cf2fb389527a670330dd892d65d15.jpeg",
    "https://cdn.faire.com/fastly/2a5a914d8c02349965a70c4ecee5d50b88d5158fd102d5739c2019431ca9a5b4.jpeg",
  ],
  priceDollars: 10.77,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel ，Zircon，18K gold plated\nSize of pendant : 26mm*55mm\nLength of chain : 460mm+50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 26.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:26.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
